import React from 'react'
import { Banner, Text } from '@fielded/shared-ui'
import { WifiOff } from '@fielded/shared-ui/src/icons'

const OfflineBanner = () => {
  return (
    <Banner
      title='YOU ARE OFFLINE'
      type='attention'
      icon={<WifiOff size={20} />}
      inline
      center={false}
      tight
    >
      <Text>
        Delivery will sync when you connect to internet.
      </Text>
    </Banner>
  )
}

export default OfflineBanner
